import { Text } from "@chakra-ui/react";

export const FormControlOptionalMark = () => {
  return (
    <Text fontSize={"xs"} fontWeight={500} color={"leadpro.500"}>
      OPTIONAL
    </Text>
  );
};
